import axiosClient from "./axiosClient";

const shopGroupApi = {
  create: (data) => {
    return axiosClient.post("/shop-groups", data);
  },
  getAll: (staffId) => {
    return axiosClient.get("/shop-groups", { params: { staffId } });
  },
  getById: (id, staffId) => {
    return axiosClient.get(`/shop-groups/${id}`, { params: { staffId } });
  },
  update: (id, data) => {
    return axiosClient.put(`/shop-groups/${id}`, data);
  },
  delete: (id, staffId) => {
    return axiosClient.delete(`/shop-groups/${id}`, { params: { staffId } });
  },
};

export default shopGroupApi;
